import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaChevronLeft, FaChevronRight, FaCheckCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
// ✅ Services data
const services = [
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_modern_flat-style_vector_illustration_in_the_same_soft_green_and_blue_color_palette_as_the_1.jpg?v=1765451416",
    ],
    title: "Tally Essentials",
    mode: "offline",
    description:
      "A complete foundational Tally course designed for students, job seekers, and beginners to become job-ready accounting professionals.",
    details: `
Duration: 2 Months
Mode: offline
Ideal For: Students, graduates, job seekers, accounting beginners.

Course Highlights
– Step-by-step Tally learning
– Practical exercises for every chapter
– Real business scenario case studies
– GST, TDS, and Payroll processing

You Will Learn
– Fundamentals of Accounting
– Company creation & masters
– Voucher entries
– Inventory management
– GST filing and compliance
– Payroll setup and payslips
– MIS reports for decision-making

Outcome:
A complete job-ready accounting professional.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/A_high-end_3D_isometric_render_of_a_digital_workspace_dedicated_to_finance._The_scene_is_bathed_in_T_1.jpg?v=1767885013",
    ],
    title: "Tally Professional",
    mode: "offline",
    description: "Master modern business automation with TallyPrime and handle advanced business operations efficiently.",
    details: `
Duration: 3 Months
Mode: offline
Ideal For: Professionals, graduates, accountants seeking advanced skills.

Course Highlights
– Learn advanced business operations
– Reconciliations
– Transaction audit
– Data security and control management

You Will Learn
– Full business operations management using TallyPrime
– Handling complex transactions and reconciliations
– Data control and audit procedures
– Inventory & financial management

Outcome:
Become capable of handling full business operations using TallyPrime.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_clean_modern_flat-style_vector_illustration_in_soft_pastel_green_and_blue_tones_matching_5.jpg?v=1765453859"
    ],
    title: "Tally Prime Basics",
    mode: "offline",
    description:
      "A beginner-friendly course to understand the core fundamentals of TallyPrime and start managing basic accounting tasks.",
    details: `
Duration: 1 Month
Mode: offline
Ideal For: Students, beginners, small business owners.

Course Highlights
– Introduction to TallyPrime interface
– Basic company creation
– Fundamental accounting entries
– Ledger & group management

You Will Learn
– Basics of accounting principles
– Creating and managing ledgers/groups
– Simple voucher entries (Payment, Receipt, Sales, Purchase)
– Basic reports like Day Book & Balance Sheet

Outcome:
Able to manage basic accounting tasks confidently using TallyPrime.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Designer_33.jpg?v=1768723685"
    ],
    title: "Principles of Tally Bookkeeping",
    mode: "online",
    description:
      "Build a strong foundation in accounting and bookkeeping principles using Tally, essential for accurate financial record-keeping.",
    details: `
Duration: 2 Months
Mode: online
Ideal For: Students, beginners, commerce aspirants, and non-accounting professionals.

Course Highlights
– Core bookkeeping concepts
– Accounting rules and principles
– Practical journal entries
– Real-world accounting examples

You Will Learn
– Fundamentals of bookkeeping and accounting principles
– Debit & Credit rules (Golden Rules of Accounting)
– Journal entries and ledger posting
– Trial balance preparation
– Understanding profit & loss and balance sheet basics

Outcome:
Gain a solid understanding of bookkeeping principles and confidently record financial transactions using Tally.
  `
  },
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Designer_35.jpg?v=1768724197"
    ],
    title: "Tally Prime with GST Fundamentals",
    mode: "online",
    description:
      "Learn GST concepts and compliance while managing taxation and returns efficiently using TallyPrime.",
    details: `
Duration: 2 Months
Mode: online
Ideal For: Students, accountants, small business owners, and professionals handling GST.

Course Highlights
– GST fundamentals and structure
– GST setup in TallyPrime
– Taxable transactions handling
– GST compliance and returns

You Will Learn
– Basics of GST (CGST, SGST, IGST)
– Configuring GST in TallyPrime
– Creating GST-enabled ledgers and stock items
– Recording GST sales and purchase transactions
– Generating GST reports and returns (GSTR-1, GSTR-3B)

Outcome:
Ability to manage GST-compliant accounting and taxation processes confidently using TallyPrime.
  `
  },
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Designer_36.jpg?v=1768724481"
    ],
    title: "Financial Markets and Services",
    mode: "online",
    description:
      "Understand the structure, functions, and operations of financial markets and services essential for modern finance careers.",
    details: `
Duration: 2 Months
Mode: online
Ideal For: Commerce students, finance aspirants, MBA candidates, and professionals entering the finance sector.

Course Highlights
– Overview of financial systems
– Capital and money markets
– Banking and non-banking financial services
– Regulatory framework and institutions

You Will Learn
– Structure and functions of financial markets
– Capital market instruments and operations
– Money market instruments
– Role of banks and NBFCs
– Mutual funds, insurance, and merchant banking basics
– Regulatory bodies (RBI, SEBI) and their functions

Outcome:
Develop a clear understanding of financial markets and services, enabling informed financial decisions and career readiness in finance-related roles.
  `
  },
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Designer_37.jpg?v=1768724801"
    ],
    title: "TDL Essentials (Tally Definition Language)",
    mode: "online",
    description:
      "Learn the fundamentals of Tally Definition Language (TDL) to customize, extend, and automate TallyPrime as per business needs.",
    details: `
Duration: 1.5 Months
Mode: online
Ideal For: Tally users, developers, accountants, and professionals interested in Tally customization.

Course Highlights
– Introduction to TDL concepts
– Customization of TallyPrime
– Report and screen modifications
– Automation and extensions

You Will Learn
– Basics of TDL architecture and syntax
– Creating custom fields, forms, and reports
– Modifying existing Tally screens
– Writing simple TDL programs
– Automating business processes in TallyPrime

Outcome:
Acquire essential TDL skills to customize TallyPrime, improve efficiency, and support business-specific requirements.
  `
  },
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_clean_modern_flat-style_vector_illustration_using_the_same_soft_green_and_blue_color_palet_2.jpg?v=1765452333"
    ],
    title: "GST Using Tally Prime",
    mode: "offline",
    description:
      "A complete practical GST training designed to help learners manage GST billing, filing, and compliance using TallyPrime.",
    details: `
Duration: 1.5 Months
Mode: offline
Ideal For: Accounting students, working professionals, business owners.

Course Highlights
– Complete GST setup in TallyPrime
– GST invoicing & taxation
– Input tax credit management
– GST returns preparation

You Will Learn
– GST concepts & structure
– Creating GST-enabled masters
– Sales/Purchase entries with GST
– RCM, E-way bills & credit notes
– Generating GSTR reports in TallyPrime

Outcome:
Confidently manage GST billing, compliance, and reports using TallyPrime.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_clean_modern_flat-style_vector_illustration_using_the_same_soft_green_and_blue_color_palet_4.jpg?v=1765452334"
    ],
    title: "TDS Using Tally",
    mode: "offline",
    description:
      "A practical course focused on TDS setup, calculation, and return preparation using TallyPrime.",
    details: `
Duration: 1 Month
Mode: offline
Ideal For: Accountants, finance students, HR/payroll staff.

Course Highlights
– TDS configuration in TallyPrime
– TDS entries on various payments
– TDS payable & receivable tracking
– TDS reports & filing process

You Will Learn
– TDS sections & applicability
– Creating TDS nature of payments
– Recording TDS on salary & non-salary transactions
– Generating Form 26Q/24Q reports

Outcome:
Able to manage TDS calculations and reporting efficiently using TallyPrime.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/A_conceptual_corporate_hero_image_for_Payroll_services._An_abstract_3D_representation_of_a_clock_gea.jpg?v=1767885013"
    ],
    title: "Payroll",
    mode: "online",
    description:
      "Learn complete payroll management including salary structures, attendance, and statutory compliance using TallyPrime.",
    details: `
Duration: 1.5 Months
Mode: online
Ideal For: HR professionals, accountants, payroll administrators.

Course Highlights
– Payroll setup & employee creation
– Salary structures & pay heads
– Attendance & leave management
– Statutory compliance (PF/ESI/PT)

You Will Learn
– Payroll configuration in TallyPrime
– Salary processing & payslip generation
– Overtime, incentives & deductions
– Payroll statutory reports

Outcome:
Capable of managing end-to-end payroll processing using TallyPrime.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_clean_modern_flat-style_vector_illustration_using_the_same_soft_green_and_blue_color_palet.jpg?v=1765454182"
    ],
    title: "Online / Offline Courses",
    mode: "online",
    description:
      "Flexible accounting and Tally training programs available in both online and offline modes with expert trainers.",
    details: `
Duration: Varies (1–3 Months)
Mode: Online + Offline (Hybrid)
Ideal For: Students, working professionals, business owners.

Course Highlights
– Live online classes or offline classroom sessions
– Recorded videos + study materials
– Practical case studies
– Dedicated doubt-clearing support

You Will Learn
– Core TallyPrime and accounting modules
– GST, TDS, Payroll, Inventory
– Real business use cases
– Report generation & compliance handling

Outcome:
Flexible learning path to become a skilled accounting and Tally professional.
  `
  }
  ,
  {
    images: [
      "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Designer_31.jpg?v=1767885477",
    ],
    title: "Accounting Basics Crash Course",
    mode: "offline",
    description: "A quick-start course for non-commerce students to grasp essential accounting concepts and practices.",
    details: `
Duration: 1 Month
Mode: Offline
Ideal For: Non-commerce students, beginners, job seekers looking for accounting fundamentals.

Course Highlights
– Introduction to basic accounting principles
– Understanding assets, liabilities, and equity
– Journal entries and ledger posting
– Simple financial statements preparation

You Will Learn
– Fundamentals of bookkeeping
– Recording day-to-day transactions
– Preparing trial balances
– Basic income statements and balance sheets

Outcome:
Gain essential accounting knowledge and be confident in handling basic accounting tasks in any business setup.
  `
  }
  ,
  //   {
  //     images: [
  //       "https://cdn.shopify.com/s/files/1/0851/4607/5431/files/Create_a_clean_modern_flat-style_vector_illustration_using_the_same_soft_green_and_blue_color_palet_4.jpg?v=1765452334",
  //     ],
  //     title: "MS Office for Accountants",
  //     mode: "online",
  //     description: "Learn essential MS Office tools for reporting, documentation, and professional communication tailored for accountants.",
  //     details: `
  // Duration: 1 Month
  // Mode: Online
  // Ideal For: Accounting students, professionals, and beginners seeking MS Office skills for finance tasks.

  // Course Highlights
  // – Excel for accounting and financial reporting
  // – Word for professional documentation
  // – PowerPoint for effective presentations
  // – Templates and shortcuts to boost productivity

  // You Will Learn
  // – Creating and formatting spreadsheets for accounting
  // – Using formulas and functions for calculations
  // – Preparing professional reports and documents
  // – Presenting financial data effectively

  // Outcome:
  // Be equipped to handle accounting documentation, reporting, and presentations efficiently using MS Office tools.
  //   `
  //   }
  //   ,
];


const Section = styled.section`
  padding: 60px 20px;
  background-color: ${(props) => props.theme.colors.extralight};
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 2.2rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 10px;

  @media (max-width: 500px) {
    font-size: 1.8rem;
  }
`;

const SubHeading = styled.p`
  font-size: 1.1rem;
  color: ${(props) => props.theme.colors.secondary}; // replaced #666
  margin-bottom: 40px;

  @media (max-width: 500px) {
    font-size: 1rem;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 25px;
  justify-content: center;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr); /* ✅ exactly 3 columns on desktop */
  }
`;


const ServiceCard = styled(motion.div)`
  background: ${(props) => props.theme.colors.accentLight}, #f9f9f9);
  border: 1px solid #ddd; // optional: can create theme.colors.border if needed
  border-left: 4px solid ${(props) => props.theme.colors.secondary};
  border-radius: 10px;
  text-align: left;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    transform: translateY(-5px);
  }
`;


const ServiceImage = styled.img`
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
  margin: 0 auto;
`;
const ServiceContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const ServiceTitle = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;   
  font-size: 1.05rem;
  color: ${(props) => props.theme.colors.medium};
  margin-bottom: 8px;

  svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-right: 10px;
    color: ${(props) => props.theme.colors.secondary};
    transition: transform 0.3s;

    ${ServiceCard}:hover & {
      transform: scale(1.2);
    }
  }
`;

const ServiceDescription = styled.p`
  font-size: 0.95rem;
  color: ${(props) => props.theme.colors.secondary};
  line-height: 1.4;
  margin-bottom: 15px;
`;

const KnowMoreButton = styled.button`
  background: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.light};
  border: none;
  border-radius: 30px;
  padding: 8px 20px;
  font-size: 0.9rem;
  cursor: pointer;
  margin-top: auto;
  transition: background 0.3s;
  display: block;          /* make it a block element */
  margin: 10px auto 0;     /* top margin + auto left/right to center */

  &:hover {
    background: ${(props) => props.theme.colors.primary};
  }
`;


// ✅ Backdrop with fade + blur
const Backdrop = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(4px); /* adds subtle blur behind modal */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2999;
`;

// ✅ Modal container with max-height and scroll for long text
const ModalContent = styled(motion.div)`
 background: ${(props) => props.theme.colors.light};
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0; /* ensure no global padding */

  /* Remove margin if you had one */
`;


// ✅ Image remains fixed height
const ModalImage = styled.img`
  width: 100%;
  height: auto;
  max-height: 250px; /* restricts height without cropping */
  object-fit: contain;
  display: block;
  margin: 0 auto;
`;



// ✅ Modal body now scrollable if content overflows
const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  max-height: 80vh;
  /* Custom Scrollbar Styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
   background: ${(props) => props.theme.colors.extralight};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.medium};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.accentBlue};
  }
`;

const ModalTitle = styled.h3`
  color: ${(props) => props.theme.colors.medium};
  margin-bottom: 10px;
`;

const ModalDescription = styled.div`
  color: ${(props) => props.theme.colors.medium};
  font-size: 0.95rem;
  line-height: 1.6;
  padding: 0;
  text-align: left; /* Ensure text is left-aligned overall */

  p {
    margin-bottom: 12px;
    text-align: left; /* Left-align paragraphs */
  }

  ul {
    list-style-position: outside;
    padding-left: 1.5rem;
    margin-top: 0.5rem;
    margin-left: 0; /* Optional: remove default margin */
  }

  li {
    list-style-type: disc;
    margin-bottom: 6px;
    margin-left: 0; /* Keep bullets aligned neatly */
    text-align: left; /* Align list text left */
  }

  br {
    display: block;
    margin: 8px 0;
    content: '';
  }
`;


const KnowMoreButtonWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: center;
`;

const CloseButton = styled.button`
  position: absolute; /* ✅ make it absolute */
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.secondary}; 
  cursor: pointer;
  z-index: 10;

  &:hover {
    color: ${(props) => props.theme.colors.accentBlue};
  }

  @media (max-width: 480px) {
    font-size: 1.25rem;
    padding: 10px 12px;
  }
`;

const ViewMoreButton = styled.button`
  background: ${(props) => props.theme.colors.secondary};
  color: ${(props) => props.theme.colors.light};
  border: none;
  border-radius: 30px;
  padding: 10px 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
  margin: 30px auto 0;
  display: block;

  &:hover {
    background: ${(props) => props.theme.colors.primary};
  }
`;

// const ServiceImageWrapper = styled.div`
//   position: relative;
//   width: 100%;
//   overflow: hidden;

//   img {
//     width: 100%;
//     height: auto;
//     object-fit: contain;
//     display: block;
//     transition: opacity 0.4s ease;
//   }

//   /* If multiple images, apply hover fade */
//   img + img {
//     position: absolute;
//     top: 0;
//     left: 0;
//     opacity: 0;
//   }

//   &:hover img + img {
//     opacity: 1;
//   }

//   &:hover img:first-child {
//     opacity: ${(props) => (props.hasSecondImage ? 0 : 1)};
//   }
// `;

// ✅ Arrow buttons
const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.5);
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 20;
  padding: 8px;
  border-radius: 50%;
  ${(props) => (props.left ? "left: 10px;" : "right: 10px;")}
  &:hover {
    background: ${(props) => props.theme.colors.accentBlue};
  }
`;
// ✅ Each animated item
const HighlightItem = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 0.95rem;
  margin-bottom: 8px;
  transform: translateX(100%);
  opacity: 0;

  /* dynamic delay */
  ${({ index }) => `
    transition: transform 0.5s ease ${index * 0.2}s, opacity 0.5s ease ${index * 0.2}s;
  `}
`;

// ✅ Overlay
const HighlightsOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  opacity: 0;
  pointer-events: none;
`;

// ✅ Image wrapper
const ServiceImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;   /* ✅ RECTANGLE instead of square */
  overflow: hidden;
  border-radius: 14px;    /* optional: smoother UI */

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;    /* ✅ crops nicely */
    display: block;
    transition: transform 0.3s ease;
  }

  &:hover img,
  &.active img {
    transform: scale(1.05);
  }

  &:hover ${HighlightsOverlay} {
    opacity: 1;
    pointer-events: auto;

    ${HighlightItem} {
      transform: translateX(0);
      opacity: 1;
    }
  }

  &:not(:hover) ${HighlightItem} {
    transform: translateX(100%);
    opacity: 0;
  }
`;


const HighlightIcon = styled(FaCheckCircle)`
  width: 16px;   /* fixed size */
  height: 16px;  /* fixed size */
  margin-right: 8px;
  color: #FFD700; /* gold color */
  flex-shrink: 0; /* prevent shrinking */
`;
const FilterTabs = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0 40px;
  flex-wrap: wrap;
`;

const FilterTab = styled.button`
  background: transparent;
  border: none;
  font-size: 0.95rem;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 20px;
  color: ${(props) =>
    props.active
      ? props.theme.colors.light
      : props.theme.colors.secondary};
  background: ${(props) =>
    props.active
      ? props.theme.colors.secondary
      : "transparent"};
  border: 1px solid ${(props) => props.theme.colors.secondary};
  transition: all 0.3s ease;

  &:hover {
    background: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.light};
  }
`;
const EnrollButton = styled.button`
  background: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.light};
  border: none;
  border-radius: 30px;
  padding: 10px 25px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;

  &:hover {
    background: ${(props) => props.theme.colors.accentBlue};
  }
`;



const OurServices = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [activeFilter, setActiveFilter] = useState("all");
  const handleEnrollNow = (service) => {
    const phoneNumber = "919876543210"; // +91 removed

    const message = `
I am interested in this course.

Course Name: ${service.title}
Mode: ${service.mode.toUpperCase()}

Please share more details.
  `;

    const encodedMessage = encodeURIComponent(message.trim());

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

    window.open(whatsappURL, "_blank");
  };

  const handleKnowMore = (service) => {
    setSelectedService(service);
    setCurrentImageIndex(0); // reset to first image
  };

  const handleClose = () => {
    setSelectedService(null);
  };

  const handleNextImage = () => {
    setCurrentImageIndex(
      (prev) => (prev + 1) % selectedService.images.length
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex(
      (prev) => (prev - 1 + selectedService.images.length) %
        selectedService.images.length
    );
  };

  const handleViewMore = () => {
    setShowAll(true);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // set initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setShowAll(false);
  }, [activeFilter]);


  const filteredServices = services.filter((service) => {
    if (activeFilter === "all") return true;

    if (activeFilter === "online") {
      return service.mode === "online";
    }

    if (activeFilter === "offline") {
      return service.mode === "offline";
    }

    return true;
  });


  const cardsToShow = showAll
    ? filteredServices
    : isMobile
      ? filteredServices.slice(0, 3)
      : filteredServices.slice(0, 6);


  return (
    <>
      <Helmet>
        <title>Our Services | </title>
        <meta
          name="description"
          content="Discover Circutech’s range of services — from industrial automation to smart energy systems and electrical consultancy."
        />
      </Helmet>

      <Section>
        <Heading>Our Courses</Heading>
        {/* <SubHeading>
          Delivering Smart Engineering & Technology Solutions
        </SubHeading> */}

        <FilterTabs>
          <FilterTab
            active={activeFilter === "all"}
            onClick={() => setActiveFilter("all")}
          >
            All Courses
          </FilterTab>

          <FilterTab
            active={activeFilter === "online"}
            onClick={() => setActiveFilter("online")}
          >
            Online Courses
          </FilterTab>

          <FilterTab
            active={activeFilter === "offline"}
            onClick={() => setActiveFilter("offline")}
          >
            Offline Courses
          </FilterTab>
        </FilterTabs>

        <ServicesGrid>
          {cardsToShow.map((service, index) => (
            <ServiceCard
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
            >
              <ServiceImageWrapper>
                <img src={service.images[0]} alt={service.title} />

                {/* Overlay for Course Highlights */}

              </ServiceImageWrapper>
              <ServiceContent>
                <ServiceTitle>{service.title}</ServiceTitle>

                <KnowMoreButtonWrapper>
                  <KnowMoreButton onClick={() => handleKnowMore(service)}>
                    Know more
                  </KnowMoreButton>
                </KnowMoreButtonWrapper>
              </ServiceContent>
            </ServiceCard>
          ))}
        </ServicesGrid>

        {!showAll && services.length > (isMobile ? 3 : 6) && (
          <ViewMoreButton onClick={handleViewMore}>See All</ViewMoreButton>
        )}

        <AnimatePresence>
          {selectedService && (
            <Backdrop
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <ModalContent
                initial={{ scale: 0.8, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                exit={{ scale: 0.8, opacity: 0 }}
              >
                <CloseButton onClick={handleClose}>
                  <IoClose />
                </CloseButton>
                <ModalBody>
                  <ModalTitle>{selectedService.title}</ModalTitle>
                  {selectedService.details.includes("–") ? (
                    <ModalDescription>
                      <ul style={{ paddingLeft: "1.5rem", margin: 0 }}>
                        {selectedService.details.split("\n").map((line, idx) => {
                          const trimmed = line.trim();
                          if (trimmed.startsWith("–")) {
                            return (
                              <li key={idx} style={{ marginBottom: "0.5rem" }}>
                                {trimmed.replace(/^–\s*/, "")}
                              </li>
                            );
                          } else if (trimmed === "") {
                            return <br key={idx} />;
                          } else {
                            return <p key={idx}>{trimmed}</p>;
                          }
                        })}
                      </ul>
                    </ModalDescription>
                  ) : (
                    <ModalDescription>
                      <p>{selectedService.details}</p>
                    </ModalDescription>
                  )}
                  <EnrollButton onClick={() => handleEnrollNow(selectedService)}>
                    Enroll Now
                  </EnrollButton>

                </ModalBody>
              </ModalContent>
            </Backdrop>
          )}
        </AnimatePresence>
      </Section>
    </>
  );
};

export default OurServices;
